import { LeadDiscoveryPage } from '@/features/leads/search/lead-discovery-page'

export default function LeadDiscoverPage() {
  return <LeadDiscoveryPage />
}
